import { validateEmail, validatePersonName } from "../../utilities/validation"

export function validateEditPageInput(key, value){
    let trueFalseFields = ["ATSC1 VP1 Deployed", "ATSC3 Deployed", "Google Analytics Deployed", "Headlines Newsletter", "ATSC3 Host Status", "News App", "Signal Signed", "Weather Newsletter", "Receiving Daily WO Logs"]
    if (trueFalseFields.includes(key)) return trueFalseValidator(value)

    else if (key === 'Affiliate') return affiliateValidator(value)
    else if (key === 'Call Sign') return callSignValidator(value)
    else if (key === 'DMA Code') return dmaCodeValidator(value)
    else if (key === 'Time Zone') return timeZoneValidator(value)

    else return true;
}

export function formatEditPageInput(key, value){

    if (typeof value === "string") value = value.trim()
    

    if (["t", "true"].includes(String(value).toLowerCase())) return 'True'
    else if (["f", "false"].includes(String(value).toLowerCase())) return 'False'

    else if (key === 'Affiliate' || key === 'Call Sign' || key === 'Time Zone'){
        value = value.toUpperCase()
    }

    else if (key === 'DMA Code' || key === 'Major.Minor VCN' || key === 'Verance Service ID' || key === 'BSID3/TSID1'){
        value = Number(value)
    }

    else if (key === 'Station Contacts'){
        for(let i = 0; i < value.length; i++){
            value[i].name = value[i].name.replace(/(^\w|\s\w)/g, m => m.toUpperCase());
        }
    }

    return value
}

export function formatChannelAttributeName(channelAttributeName){
  
    //Special Cases
    if (channelAttributeName === "major_minor_virtual_channel_number") channelAttributeName = "Major.Minor VCN"
    else if (channelAttributeName === "bsid3_or_tsid1_verance_required_info") channelAttributeName = "BSID3/TSID1"
    else if (channelAttributeName === "website_vod_assets") channelAttributeName = "Website"
    else if (channelAttributeName === "wide_orbit_log_recieved_format") channelAttributeName = "Wide Orbit Log Format"
    else if (channelAttributeName === "host_or_non_host_for_atsc3") channelAttributeName = "ATSC3 Host Status"
    else if (channelAttributeName === "google_analytics_deployment_verified") channelAttributeName = "Google Analytics Deployed"
    else if (channelAttributeName === "affiliation") channelAttributeName = 'Affiliate'
  
    //General Cases
    else {
        channelAttributeName = channelAttributeName.replace(/_/g, ' ')
        channelAttributeName = channelAttributeName.replace(/atsc/g, 'ATSC')
        channelAttributeName = channelAttributeName.replace(/^dma /g, 'DMA ')
        channelAttributeName = channelAttributeName.replace(/ vp1 /g, ' VP1 ')
        channelAttributeName = channelAttributeName.replace(/^ba /g, 'BA ')
        channelAttributeName = channelAttributeName.replace(/ ba /g, ' BA ')
        channelAttributeName = channelAttributeName.replace(/ gsid$/g, ' GSID')
        channelAttributeName = channelAttributeName.replace(/ ip /g, ' IP ')
        channelAttributeName = channelAttributeName.replace(/ id$/g, ' ID')
        channelAttributeName = channelAttributeName.replace(/ uuid$/g, ' UUID')
        channelAttributeName = channelAttributeName.replace(/(^\w|\s\w)/g, m => m.toUpperCase());
    }
  
    return channelAttributeName 
}


function trueFalseValidator(value){
    value = value.toLowerCase()
    if (value === 'true' || value === 'false' || value === 't' || value === 'f') return true
    else return false
}

function affiliateValidator(value){
    let validAffiliates = ["", "abc", "catchycomedy", "cbs", "cw", "cw/mytv", "dabl", "fox", "independent", "ktxs rebroadcast", "metv",
                           "mynet", "mytv", "nbc", "pbs", "tbd", "telemundo", "unimas", "univision", "test"]
    value = value.toLowerCase()

    if (validAffiliates.includes(value)) return true
    return false
}

function callSignValidator(value){
    let specialCallSigns = ["", "fema", "sealab", "omlab", "test"]
    value = value.toLowerCase()
    if (specialCallSigns.includes(value)) return true


    let firstLetter = value.charAt(0)
    if (value.length === 4 && (firstLetter === 'k' || firstLetter === 'w')) return true
    
    let hyphen = value.charAt(4)
    if (value.length === 7 && hyphen === '-' && (firstLetter === 'k' || firstLetter === 'w')) return true

    return false
}

function dmaCodeValidator(value){
    let regex = /^[5-8]\d\d$/
    if (value === "" || regex.test(value) || value === '-1') return true
    return false
}

function timeZoneValidator(value){
    let validTimeZones = ["", 'akst', 'akdt', 'ast', 'adt', 'est', 'edt', 'cst', 'cdt', 'hst', 'hdt', 'mst', 'mdt', 'sst', 'sdt', 'pst', 'pdt', "test"]
    value = value.toLowerCase()
    if (validTimeZones.includes(value)) return true
    return false
}

export function stationContactValidator(value){

    let errors = []

    for (let i = 0; i < value.length; i++){
        let contact = value[i]
        if (validatePersonName(contact.name) === false) errors.push([i, 'name'])
        if (validateEmail(contact.email) === false) errors.push([i, 'email'])
    }
    return errors
}
